<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-08-07 
-->
<template>
  <div class="nothing-warp">
    <img :src="static_img_url + 'pic/none-data.png?v=' + $store.state.imgVersion" />
    <div class="nothing-text">{{title | dealLanguage(enTitle)}}</div>
    <slot></slot>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: {
      default: '暂无相关数据'
    },
    enTitle: {
      default: 'No related data'
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
    }),
  },
}
</script>
<style lang='stylus' scoped>
.nothing-warp
  display flex
  flex-direction column
  justify-content center
  align-items center
  .nothing-text
    color #666
  .btn
    color #fff
    background-color #FA5A00
    border-color #FA5A00
    box-shadow none
    transition all 0.3s
    text-align center
</style>